import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { validatePro } from "../data/validators/sign_up";
import Input from "../../../booking/ui/shared/components/form/Input";
import FieldContainer from "../../../booking/ui/shared/containers/form/FieldContainer";
import ErrorContainer from "../../../booking/ui/shared/containers/form/ErrorContainer";
import PhoneNumberInput from "../../../booking/ui/shared/components/form/PhoneNumberInput";
import { Button } from "../../../booking/ui/shared/components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { requestAccountBusiness } from '../data/account/actions/signUpPro';

export default function SignUpPro() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal)
    const { success } = useSelector(state => state.account.signUpBusiness)

    const inputClass = "rounded-md w-full border-white";

    return (
        <Form
            onSubmit={(values) => {
                values.email = email;
                return (
                    dispatch(requestAccountBusiness(values)).then(() => ({})))
            }}
            validate={validatePro}
        >
            {({ handleSubmit, pristine, form, submitting, invalid, values, validating }) => {
                return (
                        <form className="flex flex-col gap-3 sm:w-[400px]" onSubmit={handleSubmit}>
                        {success&&
                        <>
                            <div className="bg-green-300  border-green-700 p-4 mb-2 rounded-md" role="alert">
                                {t('account.success_message')}
                            </div>
                        </>
                        }
                            <FieldContainer name="agencyName" className="w-full">
                                <Field
                                    className={inputClass}
                                    id="agencyName"
                                    name="agencyName"
                                    type="text"
                                    component={Input}
                                    placeholder={t('account_button.business_name')}
                                />
                                <ErrorContainer name="agencyName" className="help-block" />
                            </FieldContainer>
                            <FieldContainer name="firstName" className="w-full">
                                <Field
                                    className={inputClass}
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    component={Input}
                                    placeholder={t('account_button.first_name')}
                                />
                                <ErrorContainer name="firstName" className="help-block" />
                            </FieldContainer>
                            <FieldContainer name="lastName" className="w-full">
                                <Field
                                    className={inputClass}
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    component={Input}
                                    placeholder={t('account_button.last_name')}
                                />
                                <ErrorContainer name="lastName" className="help-block" />
                            </FieldContainer>
                            <FieldContainer name="phoneNumber" className="w-full text-black">
                                <Field
                                    className={inputClass}
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    placeholder={t(
                                        "account_button.phone"
                                    )}
                                    component={PhoneNumberInput}
                                />
                                <ErrorContainer name="phoneNumber" className="help-block" />
                            </FieldContainer>

                            <FieldContainer form="sign_up" name="cgv">
                                <ErrorContainer form="sign_up" name="cgv" />
                            </FieldContainer>

                            <div className="flex justify-center">
                                <Button
                                    type="submit"
                                    disabled={pristine || submitting || invalid}
                                    loading={submitting}
                                    icon={pristine || invalid ? "ban" : "check"}
                                    className="my-5 rounded-md bg-orange-500 p-3 text-white"
                                >
                                    {t('account_button.create_my_account')}
                                </Button>
                            </div>

                        </form>
                );
            }}
        </Form>
    )
}